import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

export const SPINNER_DEFAULT_VALUES = {
  color: 'primary',
  mode: 'indeterminate' as ProgressSpinnerMode,
  value: 50,
  diameter: 50,
} as const;
